import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_video_box()
})

function dhsv_vc_video_box() {
  $('.dhsv_video_box__container img').on('click', function () {
    const $videoBoxContainer = $(this).parent()

    const video = $videoBoxContainer.find('video.js-video-element')[0]
    if (video) {
      video.play()
    }

    const embed = $videoBoxContainer.find('embed')[0]
    if (embed) {
      const src = embed.src
      embed.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1'
    }

    $(this).hide()
  })
}
